import React from 'react';
import { useSelector } from 'react-redux';
import { CheckboxGrid } from '@directsoftware/ui-kit-web-admin';
import amenitiesList from '../resources/amenities_list.json';
import { filterAmenitiesList } from '../../../../shared/amenitiesFilter';
import { selectListingsSearchState } from '../../../redux/slices/listingsSearch';
import { useDetectMobile } from '../../../../shared/hooks/useDetectMobile';

const ListingsSearchAmenities = ({ updateSearchState }) => {
  const { isMobile } = useDetectMobile();
  const brand = useSelector(state => state.brand);
  const { selectedAmenities } = useSelector(selectListingsSearchState);
  const amenities = filterAmenitiesList(amenitiesList, brand);

  const onAmenityClick = amenity => {
    const currentIndex = selectedAmenities.indexOf(amenity);
    if (currentIndex === -1) {
      updateSearchState({
        selectedAmenities: [...selectedAmenities, amenity],
        isDirty: true
      });
    } else {
      const selectedAmenitiesClone = [...selectedAmenities];
      selectedAmenitiesClone.splice(currentIndex, 1);
      updateSearchState({
        selectedAmenities: selectedAmenitiesClone,
        isDirty: true
      });
    }
  };

  return (
    <>
      <CheckboxGrid
        customColor={brand.brand_info.colors?.color_primary}
        checkboxes={Object.keys(amenities)
          .sort()
          .map(amenity => {
            return {
              label: amenity,
              value: amenity,
              onChange: () => onAmenityClick(amenity),
              checked:
                selectedAmenities.length > 0 &&
                selectedAmenities.includes(amenity)
            };
          })}
        numberOfColumns={isMobile ? 1 : 2}
      />
    </>
  );
};

export default ListingsSearchAmenities;
